import colors from 'styles/colors';
import {
  COMPETITION_COMPLETED_STATUS,
  COMPETITION_ONGOING_STATUS,
  COMPETITION_UPCOMING_STATUS,
} from 'constants/competitions';

const CompetitionItemStyles = {
  itemContainer: {
    width: '100%',
    border: `1px solid ${colors.border.border_10p}`,
    borderRadius: '8px',
    cursor: 'pointer',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0px -4px 10px -2px rgba(0, 96, 250, 0.5), 0px 4px 10px -2px rgba(0, 96, 250, 0.5), 0px 2px 4px rgba(0, 96, 250, 0.3), 0px 1px 6px rgba(0, 96, 250, 0.1)',
    },
  },
  contentContainer: {
    padding: '32px 24px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  descriptionContainer: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    color: colors.text.primary,
    height: '17px',
    fontWeight: '600',
    fontSize: '24px',
    lineHeight: '24px',
  },
  descriptionText: {
    marginTop: '16px',
    fontSize: '16px',
    lineHeight: '22.4px',
    flex: 1,
    overflowY: 'auto',
    minHeight: '45px',
    maxHeight: '45px',
    color: colors.text.secondary,
  },
  prize: {
    color: colors.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '30px',
    height: '35px',
  },
  status: (status) => {
    // Normalize to uppercase to match predefined constants
    const normalizedStatus = status.toUpperCase();

    const statusColors = {
      [COMPETITION_UPCOMING_STATUS]: colors.primary.light,
      [COMPETITION_ONGOING_STATUS]: colors.success.main,
      [COMPETITION_COMPLETED_STATUS]: colors.text.disabled,
    };
    return {
      color: statusColors[normalizedStatus] || colors.text.secondary,
      fontWeight: '600',
      marginRight: '2px',
      border: `1px solid ${statusColors[normalizedStatus] || colors.border.border_10p}`,
      padding: '12px',
      fontSize: '14px',
      lineHeight: '14px',
      borderRadius: '100px',
      background: colors.background.button,
    };
  },
};
export default CompetitionItemStyles;
